import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

import { formatCoins, formatCps } from '../../lib/idle/format';
import { useIdle } from '../../lib/idle/idleStore';
import { usePremium, useSession } from '../../lib/session';
import { useUI } from '../../lib/ui';
import Coin from '../Idle/Coin';
import GemIcon from '../Idle/GemIcon';
import LicensingModal from '../LicensingModal/LicensingModal';
import Styles from './GameHeader.module.css';

const GameHeader = () => {
  const navigate = useNavigate();
  const [showLicensing, setShowLicensing] = useState(false);
  const coins = useIdle((s) => s.coins);
  const gems = useIdle((s) => s.gems);
  const cps = useIdle((s) => s.cps);
  const user = useSession((s) => s.user);
  const username = useSession((s) => s.username);
  const premium = usePremium();
  const openPricing = useUI((s) => s.openPricing);

  const modeClass = ({ isActive }) => `${Styles.mode} ${isActive ? Styles.modeOn : ''}`;

  return (
    <header className={Styles.header}>
      <div className={Styles.left}>
        <span className={Styles.balance} title="Coins">
          <Coin size={26} />
          <strong>{formatCoins(coins)}</strong>
        </span>
        <span className={Styles.balance} title="Gems">
          <GemIcon size={24} />
          <strong>{formatCoins(gems)}</strong>
        </span>
        <span className={Styles.rate}>+{formatCps(cps)} coins/sec</span>
      </div>

      <nav className={Styles.modes} aria-label="Practice mode">
        <NavLink to="/" end className={modeClass}>
          Flashcards
        </NavLink>
        <NavLink to="/scales" className={modeClass}>
          Scales
        </NavLink>
      </nav>

      <div className={Styles.right}>
        <button type="button" className={Styles.directorBtn} onClick={() => setShowLicensing(true)}>
          For Band Directors
        </button>
        {!user && (
          <button type="button" className={Styles.cta} onClick={() => navigate('/signup')}>
            Save progress
          </button>
        )}
        {user && !premium && (
          <button
            type="button"
            className={Styles.cta}
            onClick={() => openPricing('Premium keeps your band playing while you are away.')}
          >
            Upgrade
          </button>
        )}
        {user && (
          <button type="button" className={Styles.avatar} onClick={() => navigate('/profile')} title={username}>
            {(username || '?')[0].toUpperCase()}
          </button>
        )}
      </div>

      {showLicensing && <LicensingModal onClose={() => setShowLicensing(false)} />}
    </header>
  );
};

export default GameHeader;